import colorConfigs from './colorConfigs';

// Shared by ordinary buttons and the table's built-in icon controls.
export const neutralButtonStyle = {
  color: colorConfigs.text,
  backgroundColor: '#f5f6f6',
  border: '1px solid #818b88',
  borderRadius: '6px',
  boxShadow: 'none',
  '&:hover': {
    color: colorConfigs.text,
    backgroundColor: '#e8edeb',
    borderColor: '#52615b',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    color: '#606c66',
    backgroundColor: '#edf0ee',
    borderColor: '#c4cbc7',
    boxShadow: 'none',
  },
};

export const buttonFocusStyle = {
  '&.Mui-focusVisible, &:focus-visible': {
    outline: `3px solid ${colorConfigs.text}`,
    outlineOffset: '2px',
  },
};

export const primaryButtonStyle = {
  ...neutralButtonStyle,
  border: `2px solid ${colorConfigs.buttons.primaryBorder}`,
  backgroundColor: colorConfigs.buttons.contained,
  '&:hover': {
    ...neutralButtonStyle['&:hover'],
    borderColor: '#1e67cf',
    backgroundColor: '#e4edfc',
  },
};

export const tableIconButtonStyle = {
  ...neutralButtonStyle,
  ...buttonFocusStyle,
  width: 40,
  minWidth: 40,
  height: 40,
  minHeight: 40,
  padding: '8px',
  boxSizing: 'border-box' as const,
  '& .MuiSvgIcon-root': { fontSize: 20 },
};
